import { Component, OnInit, inject, signal } from '@angular/core';
import { ShiveRenderService } from '../../core/services/rendering/shive-render.service';
import { DrawerSidebarWidth } from './myTodos.constants';

@Component({
  selector: 'app-my-todos',
  templateUrl: './my-todos.component.html',
  styleUrl: './my-todos.component.scss',
  standalone: false,
})
export class MyTodosComponent implements OnInit {
  // Signal
  drawerSidebarWidth = signal(DrawerSidebarWidth);

  // DI
  private readonly shiveRenderService = inject(ShiveRenderService);

  ngOnInit(): void {
    this.shiveRenderService.setCssVar('--todo-drawer-width', this.drawerSidebarWidth());
  }
}
